import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SanitizeResourceUrlPipe } from './sanitize-resource-url.pipe';
import { SanitizeUrlPipe } from './sanitize-url.pipe';
import { SanitizeHtmlPipe } from './sanitize-html.pipe';

@NgModule({
  declarations: [SanitizeUrlPipe, SanitizeResourceUrlPipe, SanitizeHtmlPipe],
  imports: [CommonModule],
  exports: [SanitizeUrlPipe, SanitizeResourceUrlPipe, SanitizeHtmlPipe],
})
export class SanitizePipeModule {}
